var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticClass:"video",attrs:{"playsinline":"","webkit-playsinline":"true","x5-playsinline":"true","preload":"auto","controls":"","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }